import FromSelector from './components/from_selector'

window.MailFromSelector = FromSelector
